import { render, staticRenderFns } from "./GalleryPicker.vue?vue&type=template&id=3dca14c0&scoped=true&"
import script from "./GalleryPicker.vue?vue&type=script&lang=js&"
export * from "./GalleryPicker.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPicker.vue?vue&type=style&index=0&id=3dca14c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca14c0",
  null
  
)

export default component.exports